import React, { Component } from 'react';
import { Modal, Select, Button, Tooltip, message } from "antd";
import { remoteHospitalList, getApplyReferredData, referralMsgNotice } from '@/request/api'
import { requestErrorLog } from "@/common/util";

const { Option } = Select;
class ApplyReferral extends Component {
      state = {
            consulationList: []
      }

      componentDidMount() {
            this.initApplHospCode()
      }

      initApplHospCode() { //获取会诊医院列表
            const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
            let params = {
                  Type: "Remote",
                  hospital_Code: userInfo.HOSPITAL_CODE
            }
            remoteHospitalList(params).then((res) => {
                  if (res && res.Status === 1) {
                        const applyData = res.Result
                        let consulationList = applyData.filter(item => item.CONSULTATION_HOSPITAL_CODE !== userInfo.HOSPITAL_CODE)
                        this.setState({
                              consulationList: consulationList.filter(item => item.IS_ENABLED === 1)
                        })
                  }else{
				requestErrorLog('', '患者转诊-获取转诊医院报错', 0,true)
                  }
            })
      }

      handleChangeConsulationHospital = (val, option) => { //选择转诊医院
            this.setState({
                  applyHospitalName: option.props.children,
                  applyHospitalCode: option.props.value
            })
      }

      handleApply = () => { //申请转诊
            const { rowData } = this.props;
            const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
            let requestModal = [];
            let params = [];
            if (!this.state.applyHospitalCode) {
                  message.warn('请选择转诊医院');
                  return
            }
            rowData.forEach(item => {
                  requestModal.push({
                        REFERRAL_UID: item.REFERRAL_UID,
                        REFERRAL_HOSPITAL_CODE: this.state.applyHospitalCode,//转诊医院code
                        REFERRAL_HOSPITAL_NAME: this.state.applyHospitalName//转诊医院
                  })
                  params.push({
                        MSG_CODE: "6",
                        MSG_DETAILED: `【${userInfo.HOSPITAL_NAME}】提交了一条患者【${item.NAME}】的转诊！`,
                        EVENT_ID: item.REFERRAL_UID,
                        HOSPITAL_CODE: this.state.applyHospitalCode
                  })
            })
            getApplyReferredData(requestModal).then((res) => {
                  if (res && res.Status === 1) {
                        message.success("申请转诊成功")
                        referralMsgNotice(userInfo.HOSPITAL_CODE, params)
                        this.props.onRef(false);
                        this.props.refreshTable()
                  }else{
				requestErrorLog('', '患者转诊-申请转诊报错', 0,true)
                  }
            })

      }

      handleCancel = () => {
            this.props.onRef(false);
      }

      render() {
            const { visible, rowData } = this.props
            const { consulationList } = this.state
            return (
                  <Modal
                        width={460}
                        title="选择转诊医院"
                        visible={visible}
                        maskClosable={false}
                        onCancel={this.handleCancel}  // 右上角的关闭按钮
                        footer={[
                              <Button key="save" type="primary" onClick={this.handleApply}>
                                    申请
                              </Button>,
                              <Button key="exit" type="primary" onClick={this.handleCancel}>
                                    取消
                              </Button>
                        ]}
                  >
                        <div className="consulationInfo">
                              {
                                    rowData.map((item, index) => {
                                          return <div key={index} className='applyInfo'>
                                                <Tooltip title={item.NAME}>姓名：{item.NAME}</Tooltip>
                                                <Tooltip title={item.SEX_NAME}>性别：{item.SEX_NAME}</Tooltip>
                                                <Tooltip title={item.REFERRAL_UID}>转诊编号：{item.REFERRAL_UID}</Tooltip >
                                          </div>
                                    })
                              }
                              <Select placeholder="请选择会诊医院" onChange={this.handleChangeConsulationHospital} style={{ width: '400px', margin: '10px 0px' }}>
                                    {
                                          consulationList.map((item) => (
                                                <Option key={item.CONSULTATION_HOSPITAL_CODE} value={item.CONSULTATION_HOSPITAL_CODE}>
                                                      {item.CONSULTATION_HOSPITAL_NAME}
                                                </Option>
                                          ))
                                    }
                              </Select>
                        </div>
                  </Modal>
            )
      }
}

export default ApplyReferral;